import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import GlobalStyle from './styles/global';

import MainRoutes from './routes';

import AppProvider from './hooks';

const App: React.FC = () => (
  <Router>
    <AppProvider>
      <MainRoutes />
    </AppProvider>

    <GlobalStyle />
  </Router>
);

export default App;
